(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;

    s.load(function () {
        'use strict';
        var TrackingScriptName = 'MailchimpEcommerce360';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("ecommerce360", TrackingModel);

        if (!Tracker)
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack();

        Init();

        function Init() {
            if (!CanTrack) return;

            // for every page
            var qs_mc_cid = LhApp.Function.QueryString.getValueOf('mc_cid', unescape(LhApp.Context.Request.RawUrl));
            var qs_mc_eid = LhApp.Function.QueryString.getValueOf('mc_eid', unescape(LhApp.Context.Request.RawUrl));
            //store value of campaing to a cookie in order to use them in completion if ecommerce360 is the honourable(last) affilate
            if (qs_mc_cid || qs_mc_eid) {
                //consider moving this info into db
                Cookies.set('mc_cid', qs_mc_cid, { expires: 365 });
                Cookies.set('mc_eid', qs_mc_eid, { expires: 365 });
            }

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var mc_cid = Cookies.get('mc_cid');
                var mc_eid = Cookies.get('mc_eid');

                if (mc_cid && mc_eid)
                    LhApp.Function.MailChimpEcommerce360Tracking(TrackingModel.Order.Id, mc_cid, mc_eid);
            }   
        }
    });
})();
